import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const serviceService = {
  get_all: async (search = "", limit = "", page = "", token, categoryId = "") => {
    const params = new URLSearchParams();
    params.set("search_value", search);
    params.set("limit", limit);
    params.set("page", page);
    if (categoryId) params.set("categoryId", categoryId);

    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_ALL}?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_vat_config: (token) => {
    const uri = API_ROUTES.SERVICE.GET_VAT_CONFIG;
    return https.get(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_by_id: async (service_id, token) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_BY_ID}/${service_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete: async (service_id, token) => {
    const response = await https.delete(
      `${API_ROUTES.SERVICE.DELETE}/${service_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  create_service: async (data, token) => {
    const response = await https.post(API_ROUTES.SERVICE.CREATE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  create_service_json: async (data, token) => {
    const response = await https.post(API_ROUTES.SERVICE.CREATE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  },
  edit_service: async (service_id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.SERVICE.UPDATE}/${service_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
  edit_service_json: async (service_id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.SERVICE.UPDATE}/${service_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  },
  update_vat_config: (token, data) => {
    const uri = API_ROUTES.SERVICE.UPDATE_VAT_CONFIG;

    return https.put(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
